<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <router-link
                tag="div"
                class="vx-logo cursor-pointer flex items-center"
                to="/"
              >
                <img
                  width="90%"
                  src="@/assets/images/logo/logo.png"
                  alt="login"
                  class="mx-auto"
                />
              </router-link>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <router-link
                    tag="div"
                    class="vx-logo cursor-pointer flex items-center lg:hidden"
                    to="/"
                  >
                    <img
                      width="90%"
                      src="@/assets/images/logo/logo.png"
                      alt="login"
                      class="mx-auto"
                    />
                  </router-link>
                  <h4 class="mb-4 hidden lg:block">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <form @submit.prevent="login">
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="loginUser.email"
                    @input="updateField('email')"
                    class="w-full"
                  />
                  <div class="field-error" v-if="isFieldInvalid('email')">
                    Valid Email is required
                  </div>

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="loginUser.password"
                    @input="updateField('password')"
                    class="w-full mt-6"
                  />
                  <div class="field-error" v-if="isFieldInvalid('password')">
                    Password is required
                  </div>
                  <div class="field-error" v-if="error">
                    {{ error }}
                  </div>

                  <div class="flex flex-wrap justify-between my-5">
                    <router-link to="forgot-password">
                      Forgot Password?
                    </router-link>
                  </div>
                  <vs-button type="border" to="register">Register</vs-button>
                  <vs-button
                    button="submit"
                    class="float-right"
                    @click.prevent="login"
                    >Login</vs-button
                  >
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { required, email } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      checkbox_remember_me: false,
      loginUser: { email: "", password: "" },
      error: false
    };
  },
  computed: {
    ...mapGetters({ userLoggedIn: "session/userLoggedIn" })
  },
  methods: {
    ...mapActions({
      goToDashboard: "session/goToDashboard",
      profile: "session/profile",
      sessionLogin: "session/login"
    }),
    async login() {
      this.$v.loginUser.email.$touch();
      if (!this.disabledSignIn) {
        this.error = false;
        try {
          const data = await this.sessionLogin({
            email: this.loginUser.email,
            password: this.loginUser.password
          });

          if (data["error"]) {
            this.error = data["error"];
          } else {
            await this.profile();
            this.goToDashboard();
          }
        } catch (ex) {
          this.error = ex["error"];
          console.log("ex", ex);
        }
      }
    },
    isFieldInvalid(name) {
      return this.$v.loginUser[name].$dirty && this.$v.loginUser[name].$invalid;
    },
    updateField(name) {
      this.error = false;
      this.$v.loginUser[name].$touch();
    }
  },
  mounted() {
    if (this.userLoggedIn) {
      this.goToDashboard();
    }
  },
  validations: {
    loginUser: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  metaInfo() {
    return { title: this.$route.meta.title };
  }
};
</script>
